export enum EventType {
	CAEII = 'caeii',
	CiCA = 'cica',
	ENaR = 'enar',
	JoSEII = 'joseii',
	LIDERA = 'lidera',
	RCD = 'rcd',
	SemEII = 'semeii',
	Generic = 'generic',
}